var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBattalionHouseCurve(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 748,
    height: 372,
    viewBox: "0 0 748 372",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388.844 -35.9922L543.377 27.8755L546.665 130.535L711.697 198.739L718.109 398.749",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.23 -38.2188L433.985 45.8876L438.371 180.957L655.967 270.774L664.52 533.929",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.355 -24.6406L337.681 72.8973L342.774 229.522L595.154 333.682L605.086 638.833",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.406 -49.9688L624.404 0.464708L626.994 81.5445L757.28 135.402L762.331 293.37",
    stroke: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattalionHouseCurve);
export default __webpack_public_path__ + "static/media/Battalion House Curve.356b5d93556aecb69c33622735fc7b18.svg";
export { ForwardRef as ReactComponent };